module.exports = __webpack_public_path__ + "static/media/hr-leadership-and-management-awards-img.2363a46d.png";